(function(angular) {
	angular.module('bizPartEngage').service('base.service', baseService);
    angular.module('bizPartEngage').service('bizNotificationService', bizNotificationService);
    angular.module('bizPartEngage').service('bizPushNotificationService', bizPushNotificationService);

    angular.module('bizPartEngage').service('MetadataService', ['$window', '$filter', function ($window, $filter) {
        var self = this;
        self.setMetaTags = function (tagData) {
            $window.document.getElementsByName('title')[0].content = tagData.title;
            $window.document.getElementsByName('description')[0].content = tagData.description;

            if (tagData.keywords)
                $window.document.getElementsByName('keywords')[0].content = tagData.keywords;

            //Open graph...
            if (tagData.title && tagData.title.length > 0)
                document.getElementById('og-title').content = tagData.title;

            if (tagData.description && tagData.description.length > 0)
                document.getElementById('og-description').content = tagData.description;

            if (tagData.img && tagData.img.length > 0)
                document.getElementById('og-image').content = $filter('fullsitepath')(tagData.img);

            if (tagData.video && tagData.video.length > 0)
                document.getElementById('og-video').content = $filter('fullsitepath')(tagData.video);

            document.getElementById('og-url').content = location.href;

            if (tagData.appendPortalNameLast && tagData.appendPortalNameLast === true)
                $window.document.title = htmlDecode((tagData.title.length > 0 ? tagData.title + " - " : '') + portalName);
            else
                $window.document.title = htmlDecode(portalName + (tagData.title.length > 0 ? " - " + tagData.title : '')); 
        };
    }]);

    baseService.$inject = ["$http", "$state", "$filter"];
    bizNotificationService.$inject = ["$timeout", "$mdToast"];
    bizPushNotificationService.$inject = ["$http", "$mdToast"];

    function baseService($http, $state, $filter) {
    	this.AddTranslatePartsToState = function (stateName, parts) {
    		var state = $state.get(stateName);
    		if (!state)
    			return;

    		if (!state.data)
    			state.data = { translateParts: [] };
			else if (!state.data.translateParts)
    			state.data.translateParts = [];

    		state.data.translateParts = state.data.translateParts.concat(parts);
    	}

        this.GetMenuItemsForLoggedInUser = function() {
            return $http.get(siteRootPath + 'api/menu/GetMenuItemsForLoggedInUser');
        };

        this.GetLoggedInUser = function() {
            return $http.get(siteRootPath + 'api/User/GetLoggedInUser');
        };

        this.GetCultures = function () {
            return $http.get(siteRootPath + 'api/culture/GetCultures');
        };

        this.HasLayoutComponent = function (type) {
            return $http.get(siteRootPath + 'api/layout/HasLayoutComponent', {
                params: {
                    type: type
                }
            });
        }

        this.GetGlobalSiteTitle = function () {
            return $http.get(siteRootPath + 'api/layout/GetGlobalSiteTitle');
        }

        this.GetFrontEndModuleSettingValue = function (module, key) {
            if (moduleSettings) {
                var settings = moduleSettings.GetItemByValue('ModuleName', module);
                if (settings && settings.Settings) {
                    var s = settings.Settings.GetItemByValue('Key', key);
                    return s ? s.Value : undefined;
                }
            }
            return undefined;
        }

        this.UpdateFrontEndModuleSettingValue = function (module, key, value) {            
            if (moduleSettings) {
                var settings = moduleSettings.GetItemByValue('ModuleName', module);
                if (settings && settings.Settings) {
                    var s = settings.Settings.GetItemByValue('Key', key);
                    if (s) {
                        s.Value = value;
                    }
                }
            }
        }

        this.GetSiteRootPath = function (value) {
            return $filter("siteroot")(value)
        }
    }

    function bizNotificationService($timeout, $mdToast) {
        this.AddInformationNotification = function (header, body, timeout) {
            var guid = randomString(5);
            var html = '<div id="' + guid + '" class="bizNotificationItem"><div class="bizNotificationItem-header"><i class="fa fa-info-circle info" aria-hidden="true"></i>' + header + '<i class="fa fa-times close" aria-hidden="true"></i></div><div class="bizNotificationItem-body"><i class="fa fa-check-circle-o" aria-hidden="true"></i><span>' + body + '</span></div></div>'
            var bizNotification = angular.element(document.querySelector('#bizNotification'));

            bizNotification.append(html);

            $timeout(function (id) {
                angular.element(document.querySelector('#' + id)).addClass('hide-notification');

                $timeout(function (elemId) {
                    angular.element(document.querySelector('#' + elemId)).remove();
                }, 350, true, id);

            }, timeout || 10000, true, guid);
        }

        this.AddCustomNotification = function (content) {
            var template = '<md-toast class="custom-notification">' + content + '</md-toast>';
            $mdToast.show({
                position: 'top center',
                parent: angular.element(document.body),
                hideDelay: 20000,
                template: template,
                autoWrap: true,
                controllerAs: 'vm',
                controller: function ($mdToast) {
                    var vm = this;
                    vm.close = function () {
                        $mdToast.hide();
                    }
                }
            });
        }

        function randomString(len) {
            charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
            var randomString = '';
            for (var i = 0; i < len; i++) {
                var randomPoz = Math.floor(Math.random() * charSet.length);
                randomString += charSet.substring(randomPoz, randomPoz + 1);
            }
            return randomString;
        }
    }

    function bizPushNotificationService($http, $mdToast) {
        var messaging;

        this.Initialize = function () {
            try {
                firebase.initializeApp(firebaseConfig);
                messaging = firebase.messaging();

                messaging.onMessage(function (payload) {
                    console.log('PAYLOAD', payload);
                    if (payload && payload.data && payload.data.show_on_site === "True") {
                        ShowOnSite(payload);
                    }
                });
                navigator.serviceWorker.register(siteRootPath + "firebase-messaging-sw.js")
                    .then((registration) => {
                        messaging.useServiceWorker(registration);
                        Notification.requestPermission().then((permission) => {
                            if (permission === 'granted') {
                                console.log('Notification permission granted.');
                                // TODO(developer): Retrieve an Instance ID token for use with FCM.
                                // ...
                                GetFCMToken();
                            } else {
                                console.log('Unable to get permission to notify.');
                            }
                        });
                    });

                messaging.usePublicVapidKey("BJz2MR7KAppIhe0N3M4nX2VH6boXvxpXxdVcPUVDdSL8P7kGFe1s3pYNBhSol3SV22EOkDmbB7wa4uup0G2QUQE");
            } catch (error) {
                console.log('ERROR INITIALIZING FIREBASE!');
                console.log(error);
            }            
        };

        function ShowOnSite(payload) {
            var template = '<md-toast class="push-toast" ng-click="vm.click()">' + payload.data.body + '<i class="fas fa-times" ng-click="vm.close()" /></md-toast>';
            $mdToast.show({
                position: 'top center',
                parent: angular.element(document.body),
                hideDelay: 10000,
                template: template,
                autoWrap: true,
                controllerAs: 'vm',
                controller: function ($mdToast) {
                    var vm = this;
                    vm.close = function () {
                        $mdToast.hide();
                    }
                    vm.click = function () {
                        if (payload.data.click_action) {
                            location.href = payload.data.click_action;
                        }
                    }
                }
            });
        }

        function AddPushNotificationId (notificationId, type) {
            return $http.get(siteRootPath + "api/PushNotification/AddPushNotificationId?" + $.param({ id: notificationId,
                type: type || 1 }));
        };

        function ValidatePushNotificationId (notificationId) {
            return $http.get(siteRootPath + "api/PushNotification/ValidatePushNotificationId?" + $.param({id: notificationId}));
        };

        function GetFCMToken() {
            messaging.getToken().then((currentToken) => {
                if (currentToken) {
                    console.log('Current token: ', currentToken)
                    ValidatePushNotificationId(currentToken).then(function(valid) {
                        if(!valid.data) {
                            AddPushNotificationId(currentToken);
                        }
                        else {
                            console.log('You are already registered with token: ', currentToken);
                        }
                    });

                } else {
                    // Show permission request.
                    console.log('No Instance ID token available. Request permission to generate one.');
                    // Show permission UI.
                    // updateUIForPushPermissionRequired();
                    // setTokenSentToServer(false);
                }
            }).catch((err) => {
                console.log('An error occurred while retrieving token. ', err);
                //showToken('Error retrieving Instance ID token. ', err);
                //setTokenSentToServer(false);
            });
        }
    }
})(window.angular);
